module.exports = __webpack_public_path__ + "static/media/07B.c46e5a07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/07B.png
// module id = 264
// module chunks = 0